import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError, delay, timeout } from 'rxjs/operators';

import { JWTService } from './jwt.service';
import * as _ from 'lodash-es'

import { environment } from 'src/environments/environment';
import Resources from '../constants/resources';

import { SessionStorageService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {
  constructor(
    private jwtapi: JWTService,
    private sessionService: SessionStorageService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/oauth/authorize')) {
      return next.handle(req);
    } else {
      const token = this.jwtapi.generateJWTToken('basic');
      return this.jwtapi.addKeyToCache(token.uuidVal).pipe(timeout(30000), delay(600)).pipe(switchMap((response) => {
        if (!!token?.accessToken) {
          let header = { 'Authorization': token.accessToken };

          // Added api key in the header
          if (
            req.url.includes('?companyIdentifier') ||
            req.url.includes('?charityIdentifier') ||
            req.url.includes('/electricity/addresses') ||
            req.url.includes('/gas/addresses') ||
            req.url.includes('/electricity/meter') ||
            req.url.includes('/gas/meter') ||
            req.url.includes('/electricity/meter/usage') ||
            req.url.includes('/gas/meter/usage') ||
            req.url.includes('/electricity/quotes') ||
            req.url.includes('/gas/quotes') ||
            req.url.includes('/validate-bank-account') ||
            req.url.includes('customers/loa') ||
            (req.url.includes('customers/contract') && !req.url.includes('customers/contract/db'))
          ) {
            header['api_key'] = 'ff50d815-a62c-4bd3-afcd-39926a3a23b9';
            header['modifiedby'] = this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.Email) || 'labrador';
          }
          let clone = req.clone({ setHeaders: header });
          const acquisitionId = this.sessionService.getItemFromMemory(Resources.envKey.brokers) || environment.client;
          if (req.method === 'POST' || req.method === 'PATCH') {
            let bodyObj = req.body;
            let body;
            if (req.body instanceof FormData) {
              const param = new HttpParams({ fromString: 'version=' + encodeURIComponent(environment.enc_version) + '&module=' + environment.module + '&subModule=' + acquisitionId.toUpperCase() });
              body = req.clone({ body: bodyObj, params: param, setHeaders: header });
            } else {
              bodyObj['module'] = environment.module
              bodyObj['subModule'] = acquisitionId.toUpperCase()
              bodyObj['version'] = environment.enc_version
              body = req.clone({ body: bodyObj, setHeaders: header });
            }
            return next.handle(body);
          } else if (req.method === 'GET' || req.method === 'DELETE') {
            let body = req.clone({
              params: new HttpParams({ fromString: 'version=' + encodeURIComponent(environment.enc_version) + '&module=' + environment.module + '&subModule=' + acquisitionId.toUpperCase() }), setHeaders: header
            });
            return next.handle(body);
          } else {
            return next.handle(clone);
          }
        }
      }), catchError((err) => {
        console.log('Interceptor ERROR: ', err);
        return throwError(err);
      }));

      // const jwt = this.jwtapi.getJWT();
      // if (!_.isEmpty(jwt)) {
      //   const decodedSign: any = jwt_decode(jwt);
      //   isExpired = moment().isAfter(moment(decodedSign.expires));
      // }
      // if (isExpired) {
      //   return this.jwtapi.addHashToCache('BUSINESS').pipe(delay(600)).pipe(switchMap((response) => {
      //     if (response.hash) {
      //       let clone = req.clone({ setHeaders: { 'Authorization': response.hash } });
      //       return next.handle(clone);
      //     }
      //   }), catchError((err) => {
      //     return throwError(err);
      //   }));
      // } else {
      //   let clone = req.clone({ setHeaders: { 'Authorization': jwt } });
      //   return next.handle(clone);
      // }
    }
  }

}
